import { QuoteResponse } from '../types/Quote';
import { brokerId, partnerId } from '../utils/locationSearchParams';
import { mobileApiRequest } from '../utils/request/applicationRequests';
import { ActivityAnswer } from './profession';

export type ApiQuoteReq = {
  crew: number;
  profession: ActivityAnswer;
  zipcodeAndState: [string, string];
  plan_list?: any[];
};

export const apiQuote = async ({
  crew,
  profession,
  zipcodeAndState,
  plan_list,
}: ApiQuoteReq): Promise<QuoteResponse> => {
  const date = new Date();
  const customize_duration = {
    start: {
      date: `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date
        .getDate()
        .toString()
        .padStart(2, '0')}`,
    },
    type: 'specific',
  };

  const res = await mobileApiRequest.post('/smb/quote', {
    plan_list,
    broker_id: brokerId,
    // origin_partner_id: partnerId,
    // gorup: profession.group,
    // group_id: profession.groupId,
    auto_extend: true,
    census: {
      crew,
      activity: profession.activity,
      activity_id: profession.activityId,
      searchword: profession.query,
      zipcode: zipcodeAndState[0],
      state: zipcodeAndState[1],
    },
    customize_duration,

    mobile_timezone: 'America/Los_Angeles',
    mobile_timestamp: 1460674580,
    quote_from: 'quote',
    primary_insurance_type: 'gl',
  });
  return res;
};
